import React, { useEffect, useState } from "react";
import classNames from "classnames";
import Icon from "../icon/Icon";
import { isDocumentURL } from "../../utilities/imageUtils";

// Aviable sizes {xs,sm,md,lg,xl}
/* Aviable theme {blue-dim, blue, azure-dim, azure, indigo-dim, indigo, purple-dim, purple, pink-dim, pink, orange-dim, orange, teal-dim, teal, 
    primary-dim, primary, secondary-dim, secondary, success-dim, success, info-dim, info, warning-dim, warning, danger-dim, danger, dark-dim, dark, gray-dim, gray, lighter, light} */

const UserAvatar = ({
  className,
  size,
  theme,
  icon,
  text,
  image,
  imageAlt,
  ...props
}) => {
  const [hasImageError, setHasImageError] = useState(false);

  useEffect(() => setHasImageError(false), [image]);

  const classes = classNames({
    "user-avatar": true,
    [`${className}`]: className,
    [`user-avatar-${size}`]: size,
    [`bg-${theme}`]: theme,
  });

  // Manzilda kengaytma bo'lmasligi mumkin (/api/v1/files/{id}), shuning uchun
  // kengaytma ro'yxatiga emas, rasmning haqiqatan yuklanishiga qaraymiz.
  const canShowImage = image && !isDocumentURL(image) && !hasImageError;

  const renderImage = canShowImage ? (
    <img src={image} alt={imageAlt} onError={() => setHasImageError(true)} />
  ) : (
    <span>{text}</span>
  );

  return (
    <div className={classes}>
      {icon ? <Icon name={icon} /> : null}
      {renderImage}
      {props.children}
    </div>
  );
};

export default UserAvatar;
